module.exports = __webpack_public_path__ + "static/Nanopesos2-62443ef95db08160401585a0b40e0fe7.webp";